import { useEffect } from "react";

import { useTenant } from "../lib/tenant.js";
import { loadTermly, termlyOf } from "../lib/termly.js";

/**
 * Cookie consent for this storefront: loads Termly's banner for a store that resolves a Termly
 * website, and renders the footer's "Cookie preferences" control that reopens it. Renders
 * nothing while the store has no website, which is also when nothing Termly is loaded.
 *
 * Termly wires a click handler onto the `termly-display-preferences` class when it finds the
 * element at init, but its observer never looks inside a React-rendered subtree, so the
 * `onClick` fallback is what actually opens the modal here. It is a `<button>` because Termly
 * disables the element when the website's preference widget is off.
 */
export function CookieConsent() {
  const { config } = useTenant();
  const { websiteUuid } = termlyOf(config);

  // One script per page load: loadTermly ignores a second call, so StrictMode's doubled effect
  // and a later config refetch are no-ops. A change of website lands on the next load.
  useEffect(() => {
    if (websiteUuid) void loadTermly(websiteUuid);
  }, [websiteUuid]);

  if (!websiteUuid) return null;

  return (
    <button
      type="button"
      className="termly-display-preferences hover:underline"
      onClick={() => window.displayPreferenceModal?.()}
    >
      Cookie preferences
    </button>
  );
}
